import { useEffect, useState } from 'react'
import { isEnabled as readEnabled, setEnabled as writeEnabled, installPatches } from '../lib/debugLog'

// Settings toggle for the on-device debug log. localStorage-backed
// like useAiDebugEnabled, with cross-tab sync via the storage event.
// When the user flips the toggle ON for the first time in a tab we
// also install the console patches retroactively — they were skipped
// at boot if the flag was off, so this is the moment to wire them in.
export function useDebugLogEnabled() {
  const [enabled, setEnabledState] = useState(readEnabled)

  useEffect(() => {
    if (typeof window === 'undefined') return undefined
    const onStorage = (e) => {
      if (e.key === 'phoenix.debug.enabled') setEnabledState(e.newValue === '1')
    }
    window.addEventListener('storage', onStorage)
    return () => window.removeEventListener('storage', onStorage)
  }, [])

  const setEnabled = (next) => {
    writeEnabled(!!next)
    if (next) installPatches()
    setEnabledState(!!next)
  }

  return [enabled, setEnabled]
}
